module.exports = __webpack_public_path__ + "img/icon_supervisor.8f5b0616.png";